import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import { Button, Flex, Text } from '@radix-ui/themes'
import { useAuthSession } from 'features/auth-privy'
import { DataTestIDs } from 'shared/constants'
import { DoorOutIcon } from 'shared/icons'
import { XyroLoading } from 'shared/ui'
import { notifyOnUnknownError } from 'shared/utils/notify-on-error'

export const Logout = () => {
  const { signOut, loading } = useAuthSession()

  const handleLogOut = useCallback(() => {
    signOut().catch(e => notifyOnUnknownError(e as ApolloError))
  }, [signOut])

  return (
    <Button
      onClick={handleLogOut}
      variant={'ghost'}
      type={'button'}
      disabled={loading}
      size={'3'}
      mx={'3'}
      mt={'3'}
      data-testid={DataTestIDs.buttonLogOut}
    >
      <Flex
        align={'center'}
        gap={'2'}
        p={'1'}
      >
        <XyroLoading loading={loading}>
          <DoorOutIcon color='var(--white)' />
          <Text
            className='color-white'
            size={'2'}
          >
            {!loading ? 'Log out' : 'Logging out...'}
          </Text>
        </XyroLoading>
      </Flex>
    </Button>
  )
}
